// import Case1 from "../images/mybyk-case-1.png";
// import Case2 from "../images/mybyk-case-2.png";
// import Case3 from "../images/mybyk-case-3.png";
// import Case4 from "../images/mybyk-case-4.png";
// import Case5 from "../images/mybyk-case-5.png";
import Case1 from "../images/mybyk-slider-one.jpg";
import Case2 from "../images/skip-key-hassle.png";
import Case3 from "../images/adjustable-seat.png";
import Case4 from "../images/sturdy-basket.png";
import Case5 from "../images/bottle-holder.png";

const BikeShowCaseData = [
  {
    title: "Unisex Bike",
    description:
      "Strong & lightweight frame for an optimal cycling experience.",
    image: Case1,
  },
  {
    title: "Skip Key Hassle",
    description: "Unlock peace of mind with our bluetooth enabled lock.",
    image: Case2,
  },
  {
    title: "Adjustable height",
    description: "Effortlessly adjust seat height for comfortable cycling.",
    image: Case3,
  },
  {
    title: "Sturdy basket",
    description:
      "A heavy duty front basket that can carry a payload of upto 7kgs.",
    image: Case4,
  },
  {
    title: "Bottle holder",
    description: "Convenient bottle holder for staying hydrated on your rides.",
    image: Case5,
  },
];

export default BikeShowCaseData;
